import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Spacer,
  useToast,
} from '@chakra-ui/react';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useMutation } from 'urql';
import { CreateTemplateFromProjectDocument, Project } from '../../gql/graphql';

type CreateTemplateFromProjectTabProps = {
  project: Pick<Project, 'id'>;
};

type TemplateFormValues = {
  templateName: string;
};

export default function CreateTemplateFromProjectTab({
  project,
}: CreateTemplateFromProjectTabProps): React.ReactElement {
  const { t } = useTranslation('company');
  const toast = useToast();

  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<TemplateFormValues>({ defaultValues: { templateName: '' } });

  const [, createTemplateFromProject] = useMutation(
    CreateTemplateFromProjectDocument
  );

  const onSubmit = handleSubmit(async ({ templateName }) => {
    const result = await createTemplateFromProject({
      projectId: project.id,
      templateName: templateName,
    });
    if (result.error) {
      toast({
        title: t('project-settings.template.error.create'),
        status: 'error',
      });
    } else {
      toast({
        title: t('project-settings.template.success.create'),
        status: 'success',
      });
    }
  });

  return (
    <form onSubmit={onSubmit}>
      <FormControl isRequired>
        <FormLabel>{t('project-settings.template.template-name')}</FormLabel>
        <Input
          type="text"
          {...register('templateName')}
          placeholder={t('project-settings.template.template-name')}
        ></Input>
      </FormControl>
      <HStack>
        <Spacer />
        <Button
          variant={'outline'}
          type="submit"
          alignSelf={'end'}
          isLoading={isSubmitting}
          mt={2}
        >
          {t('project-settings.template.create-template')}
        </Button>
      </HStack>
    </form>
  );
}
